import React from "react";

const getColor = (value) => {
    if (value < 30) return "#22c55e";   // green
    if (value < 70) return "#f59e0b";   // yellow
    return "#ef4444";                   // red
};

const PressureMeter = ({ value = 0, size = 160, stroke = 12, title = "work load" }) => {
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;

    const progress = Math.min(Math.max(value, 0), 100);
    const offset = circumference - (progress / 100) * circumference;

    const color = getColor(progress);

    return (
        <div style={{ width: size, height: size, position: "relative" }}>
            <svg width={size} height={size}>
                {/* Background circle */}
                <circle
                    stroke="#e5e7eb"
                    fill="transparent"
                    strokeWidth={stroke}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                />

                {/* Progress circle */}
                <circle
                    stroke={color}
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    style={{
                        transition: "stroke-dashoffset 0.6s ease, stroke 0.3s",
                        transform: "rotate(-90deg)",
                        transformOrigin: "50% 50%",
                    }}
                />
            </svg>

            {/* Center Text */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    fontFamily: "sans-serif",
                }}
            >
                <div style={{ fontSize: 24, fontWeight: "bold", color: '#0f172a' }}>
                    {progress.toFixed(0)}%
                </div>
                <div style={{ fontSize: 12, color: "#94a3b8" }}>
                    {title}
                </div>
            </div>
        </div>
    );
};

export default PressureMeter;